import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=5935cea0&scoped=true"
import script from "./NewSearch.vue?vue&type=script&lang=js"
export * from "./NewSearch.vue?vue&type=script&lang=js"
import style0 from "./NewSearch.vue?vue&type=style&index=0&id=5935cea0&prod&lang=scss&scoped=true"
import style1 from "./NewSearch.vue?vue&type=style&index=1&id=5935cea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935cea0",
  null
  
)

export default component.exports